// extracted by mini-css-extract-plugin
export default {"avatar":"style_avatar__idekO","status":"style_status__bmxRd"};